<template>
  <div>
    <el-table :data="ticketsPurchased">
      <el-table-column label="Order" width="105">
        <template slot-scope="scope">
          <a href="#">#{{ scope.row.order }}</a>
        </template>
      </el-table-column>

      <el-table-column
        prop="quantity"
        label="Quantity"
        width="105"
      ></el-table-column>

      <el-table-column label="Type" width="150">
        <template slot-scope="scope">
          <strong>{{ scope.row.purchaserType | capitalize }}</strong>
          <br />
          <span class="light">
            {{ scope.row.ticketType | capitalize }}
            <br />Tickets
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Total" width="90">
        <template slot-scope="scope">{{ scope.row.total | currency }}</template>
      </el-table-column>

      <el-table-column
        prop="purchaser"
        label="Purchaser"
        width="150"
      ></el-table-column>

      <el-table-column label="Registrant">
        <template slot-scope="scope">
          <ol>
            <li
              v-for="registrant in scope.row.registrants"
              :key="registrant.index"
            >
              {{ registrant | capitalize }}
            </li>
          </ol>

          <a href="#">Edit registrations</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ApolloEventTickets from "@/graphql/Member/EventTickets.gql";

export default {
  name: "ticketsPurchased",
  //   props: ["ticketsPurchased"]
  apollo: {
    Tickets: {
      query: ApolloEventTickets,
      variables() {
        return {
          userID: this.$store.state.user.id
        };
      },
      update(data) {
        return data.User[0].Orders;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
ol {
  margin: 0;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
}

a {
  font-weight: 700;
  font-size: 11px;
  color: #27dbb0;
  letter-spacing: 1.5px;
  line-height: 20px;
  text-transform: uppercase;
}
</style>
